import { render, staticRenderFns } from "./PortalFavoriteMenus.vue?vue&type=template&id=56a7b54a&scoped=true&"
import script from "./PortalFavoriteMenus.vue?vue&type=script&lang=ts&"
export * from "./PortalFavoriteMenus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a7b54a",
  null
  
)

export default component.exports